import { render } from "./MarketSubscription.vue?vue&type=template&id=6de48dc0&scoped=true"
import script from "./MarketSubscription.vue?vue&type=script&lang=js"
export * from "./MarketSubscription.vue?vue&type=script&lang=js"

import "./MarketSubscription.vue?vue&type=style&index=0&id=6de48dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de48dc0"]])

export default __exports__